import * as React from "react";
import BaseApp from '../../base-react/components/AppMain';
import { PrivateOutlet } from '../../base-react/components/PrivateOutlet';
import { Dashboard } from './Dashboard';
import { Overview } from '../pages/event/overview';
import { Schedule } from '../pages/event/schedule';
import { Classes } from "../pages/competition/classes";
import { Round } from "../pages/competition/round";
import { Migrate } from "./Migrate";
import { ManagerOutlet } from "./ManagerOutlet";
import { CompetitionDetails } from "../pages/event/details";
import { EventCompetitions } from "../pages/event/competitions";
import { Floor } from "../pages/event/floor";
import { DataTransfer } from "../pages/competition/data";
import { CompetitionOutlet } from "../pages/competition";
import { EventUsers } from "../pages/event/users";
import { Teams } from "../pages/competition/teams";
import { Judges } from "../pages/competition/judges";
import { Validator } from "../pages/event/validator";
import { Checkin } from "../pages/competition/checkin";
import { EventNotifications } from "../pages/event/notifications";
import { EventScreens } from "../pages/event/screens";
import { EventVoting } from "../pages/event/voting";
import { LiveResults } from "../pages/competition/live";
import { Print } from "./Print";
import { PrintStartNumber } from "../pages/competition/teams/components/PrintStartNumber";
import { Registration } from "../pages/competition/registration";
import { PrintQrCode } from "../pages/competition/registration/components/PrintQrCode";
import { PrintHeat } from "../pages/competition/teams/components/PrintHeat";
import { PrintDiploma } from "../pages/competition/teams/components/PrintDiploma";
import { PrintResult } from "../pages/competition/round/components/PrintResult";
import { PrintJudgingSheet } from "../pages/competition/round/components/PrintJudgingSheet";
import { Cafe } from "../pages/event/cafe";
import { PrintSchedule } from "../pages/event/schedule/components/PrintSchedule";
import { Sponsors } from "../pages/event/sponsors";
export const App = () => {
    return (React.createElement(BaseApp, { routes: routes }));
};
// Router configuration (object/array style)
const routes = [
    {
        children: [
            {
                path: "comp/*",
                element: React.createElement(Migrate, null),
                handle: { titleKey: "competition.title" }
            },
            {
                element: React.createElement(PrivateOutlet, null),
                children: [
                    {
                        path: "new",
                        element: React.createElement(Dashboard, null),
                        children: [
                            {
                                index: true,
                                element: React.createElement(CompetitionDetails, null),
                                handle: { titleKey: "competition.details.title" }
                            }
                        ]
                    },
                    {
                        path: "event/:event_id",
                        element: React.createElement(Dashboard, null),
                        handle: { titleKey: "sider.event" },
                        children: [
                            {
                                element: React.createElement(ManagerOutlet, null),
                                children: [
                                    {
                                        index: true,
                                        element: React.createElement(Overview, null),
                                        handle: { titleKey: "sider.overview" }
                                    },
                                    {
                                        path: "validator",
                                        element: React.createElement(Validator, null),
                                        handle: { titleKey: "validator.title" }
                                    },
                                    {
                                        path: "edit",
                                        element: React.createElement(CompetitionDetails, null),
                                        handle: { titleKey: "competition.details.title" }
                                    },
                                    {
                                        path: "competitions",
                                        element: React.createElement(EventCompetitions, null),
                                        handle: { titleKey: "competition.children.title" }
                                    },
                                    {
                                        path: "cafe",
                                        element: React.createElement(Cafe, null),
                                        handle: { titleKey: "cafe.title" }
                                    },
                                    {
                                        path: "floor",
                                        element: React.createElement(Floor, null),
                                        handle: { titleKey: "floor.title" }
                                    },
                                    {
                                        path: "users",
                                        element: React.createElement(EventUsers, null),
                                        handle: { titleKey: "users.title" }
                                    },
                                    {
                                        path: "schedule",
                                        element: React.createElement(Schedule, null),
                                        handle: { titleKey: "schedule.title" }
                                    },
                                    {
                                        path: "schedule/:page_id",
                                        element: React.createElement(Schedule, null),
                                        handle: { titleKey: "schedule.title" }
                                    },
                                    {
                                        path: "sponsors",
                                        element: React.createElement(Sponsors, null),
                                        handle: { titleKey: "sponsors.title" }
                                    },
                                    {
                                        path: "comp/:competition_id",
                                        element: React.createElement(CompetitionOutlet, null),
                                        handle: { titleKey: "sider.competition" },
                                        children: [
                                            {
                                                path: "registration",
                                                element: React.createElement(Registration, null),
                                                handle: { titleKey: "registration.title" }
                                            },
                                            {
                                                path: "data",
                                                element: React.createElement(DataTransfer, null),
                                                handle: { titleKey: "data.title" }
                                            },
                                            {
                                                path: "classes",
                                                element: React.createElement(Classes, null),
                                                handle: { titleKey: "class.plural" }
                                            },
                                            {
                                                path: "classes/:class_id/:round_id",
                                                element: React.createElement(Round, null),
                                                handle: { titleKey: "round.title" }
                                            },
                                            {
                                                path: "classes/:class_id/:round_id/:round_parent_id/:round_type",
                                                element: React.createElement(Round, null),
                                                handle: { titleKey: "round.title" }
                                            },
                                            {
                                                path: "teams",
                                                element: React.createElement(Teams, null),
                                                handle: { titleKey: "team.title" },
                                                children: [
                                                    {
                                                        path: ":team_id",
                                                        element: React.createElement(Teams, null),
                                                        handle: { titleKey: "team.details.title" }
                                                    }
                                                ]
                                            },
                                            {
                                                path: "judges",
                                                element: React.createElement(Judges, null),
                                                handle: { titleKey: "judges.plural" }
                                            },
                                            {
                                                path: "checkin",
                                                element: React.createElement(Checkin, null),
                                                handle: { titleKey: "checkin.title" }
                                            },
                                            {
                                                path: "live",
                                                element: React.createElement(LiveResults, null),
                                                handle: { titleKey: "live.title" }
                                            }
                                        ]
                                    },
                                    {
                                        path: "notifications",
                                        element: React.createElement(EventNotifications, null),
                                        handle: { titleKey: "notifications.title" }
                                    },
                                    {
                                        path: "screens",
                                        element: React.createElement(EventScreens, null),
                                        handle: { titleKey: "screen.plural" }
                                    },
                                    {
                                        path: "voting",
                                        element: React.createElement(EventVoting, null),
                                        handle: { titleKey: "voting.title" }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: "print/:competition_id",
                        element: React.createElement(Print, null),
                        handle: { titleKey: "print.showCompetition" },
                        children: [
                            {
                                path: "startnumber",
                                element: React.createElement(PrintStartNumber, null),
                                handle: { titleKey: "team.assign.label" },
                                children: [
                                    {
                                        path: ":team_start_number",
                                        element: React.createElement(PrintStartNumber, null),
                                        handle: { titleKey: "team.assign.label" }
                                    }
                                ]
                            },
                            {
                                path: "heat/:class_id/:round_id",
                                element: React.createElement(PrintHeat, null),
                                handle: { titleKey: "round.title" }
                            },
                            {
                                path: "result/:class_id/:round_id",
                                element: React.createElement(PrintResult, null),
                                handle: { titleKey: "round.results" }
                            },
                            {
                                path: "schedule",
                                element: React.createElement(PrintSchedule, null),
                                handle: { titleKey: "schedule.title" }
                            },
                            {
                                path: "judging-sheet/:class_id/:round_id",
                                element: React.createElement(PrintJudgingSheet, null),
                                handle: { titleKey: "judges.plural" }
                            },
                            {
                                path: "diploma/:class_id/:round_id",
                                element: React.createElement(PrintDiploma, null),
                                handle: { titleKey: "print.diploma.title" }
                            },
                            {
                                path: "registration",
                                element: React.createElement(PrintQrCode, null),
                                handle: { titleKey: "registration.qrcode" }
                            }
                        ]
                    }
                ]
            }
        ]
    }
];
